const ROUTE_PATH_HOME = '/';
const ROUTE_PATH_NOT_FOUND = '*';
const ROUTE_PATH_LOGIN = '/login';

export {
  ROUTE_PATH_HOME,
  ROUTE_PATH_LOGIN,
  ROUTE_PATH_NOT_FOUND,
};
